<template>
    <mslPage  :aIndex="3">
        <template v-slot:mslBody>
            <div class="company">
                <div class="banner_box">
                    <div class="banner space_center">
                        <div class="center m_center space_center">
                            <div></div>
                            <transition name="fade">
                                <div class="txt" v-if="show">
                                    <div class="title" v-if="baseInfo.company_backdrop && baseInfo.company_backdrop.id">{{ baseInfo.company_backdrop.title }}</div>
                                    <div class="content">
                                        <div class="mt_20 intro" v-if="baseInfo.company_backdrop && baseInfo.company_backdrop.id" v-html="baseInfo.company_backdrop.content"></div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="our">
                    <div class="center m_center our_center">
                        <div class="o_header column_center">
                            <div class="title" v-if="baseInfo.company_banner && baseInfo.company_banner.id">{{ baseInfo.company_banner.title }}</div>
                            <div class="intro column_center mt_12" v-if="baseInfo.company_banner && baseInfo.company_banner.id" v-html="baseInfo.company_banner.content">
                            </div>
                        </div>
                        <div class="o_content">
                            <div class="top row_center">
                                <div class="item r_position">
                                    <img src="../assets/pc_pic/company_info/1.png" alt="">
                                    <div class="content column_center a_position num b_0 r_0">
                                        <div class="iconfont iconzu303 icon"></div>
                                        <div class="name">公司愿景</div>
                                        <div class="intro">
                                            <div>成就智能健康行业</div>
                                            <div class="mt">高端优质品牌！</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item r_position">
                                    <img src="../assets/pc_pic/company_info/2.png" alt="">
                                    <div class="content column_center a_position num b_0 r_0">
                                        <div class="iconfont iconzu304 icon"></div>
                                        <div class="name">企业使命</div>
                                        <div class="intro">
                                            <div>让更多的人使用上智能健康的</div>
                                            <div class="mt">曼稣勒品牌产品！</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item r_position">
                                    <img src="../assets/pc_pic/company_info/3.png" alt="">
                                    <div class="content column_center a_position num b_0 r_0">
                                        <div class="iconfont iconzu307 icon"></div>
                                        <div class="name">员工管理</div>
                                        <div class="intro ta_center">
                                            <div>关心员工成长、强化执行能力、</div>
                                            <div class="mt">追求高效和谐、平衡激励约束！</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="top row_center mt_80">
                                <div class="item r_position">
                                    <img src="../assets/pc_pic/company_info/4.png" alt="">
                                    <div class="content column_center a_position num b_0 r_0">
                                        <div class="iconfont iconzu306 icon"></div>
                                        <div class="name">传递价值</div>
                                        <div class="intro">
                                            <div>赢在起点，一切以客户需求</div>
                                            <div>为核心价值！</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item r_position">
                                    <img src="../assets/pc_pic/company_info/5.png" alt="">
                                    <div class="content column_center a_position num b_0 r_0">
                                        <div class="iconfont iconzu305 icon"></div>
                                        <div class="name">企业精神</div>
                                        <div class="intro">
                                            <div>追求卓越品质</div>
                                            <div>铸造百年品牌</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </mslPage>
</template>

<script>
    import { baseInfo } from '../api/common.js'
    export default {
        name: "company_info",
        data() {
            return {
                baseInfo: {},
                show: false
            }
        },
        mounted() {
            this.show = true;
            this.getBaseInfo();
        },
        methods: {
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo);
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .company {
        width: 100%;
        .title {
            font-size: 30px;
            font-weight: bold;
            line-height: 38px;
            color: #262626;
        }
        .intro {
            font-size: 16px;
            font-weight: 400;
            line-height: 28px;
            color: #8C8C8C;
            text-align: center;
        }
        .banner_box {
            background-image: linear-gradient(#F7F7F7, #F1F2F1);
            .banner {
                height: 896px;
                background: url("../assets/pc_pic/company_info/company_info.png") no-repeat center center;
                background-size: auto 100%;
                .txt {
                    width: 406px;
                    .content {
                        .mt_20 {
                            margin-top: 20px;
                        }
                        &::v-deep {
                            p {
                                margin-top: 0!important;
                                margin-bottom: 0!important;
                            }
                        }
                    }
                }
            }
        }

        .our_center {
            padding: 80px 0;
            .o_header {
                .mt_12 {
                    margin-top: 12px;
                }
                &::v-deep {
                    p {
                        margin-top: 0!important;
                        margin-bottom: 0!important;
                    }
                }
            }
            .mt_80 {
                margin-top: 80px;
            }
            .o_content {
                margin-top: 80px;
                .item {
                    margin-left: 250px;
                    width: 226px;
                    height: 190px;
                    &:first-child {
                        margin-left: 0px;
                    }
                    img {
                        width: 126px;
                        height: 87px;
                    }
                    .icon {
                        font-size: 80px;
                        color:#262626;
                    }
                    .name {
                        margin-top: 26px;
                        font-size: 24px;
                        font-weight: bold;
                        line-height: 21px;
                        color: #262626;
                    }
                    .intro {
                        margin-top: 8px;
                        line-height: 20px;
                        .mt {
                            margin-top: 2px;
                        }
                        &::v-deep {
                            p {
                                margin-top: 0!important;
                                margin-bottom: 0!important;
                            }
                        }
                    }
                }
            }
        }
    }

</style>
